import { createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-064d3345"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  key: 0,
  id: "ArtistList"
};
var _hoisted_2 = {
  key: 0,
  class: "page-number"
};

var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("span", {
    class: "prompt"
  }, "~这是分页器,不许笑！~")], -1
  /* HOISTED */
  );
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_ListHead = _resolveComponent("ListHead");

  var _component_SongerList = _resolveComponent("SongerList");

  var _component_el_input_number = _resolveComponent("el-input-number");

  return _ctx.songerList.length ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createCommentVNode(" 类别选择区域 "), _createVNode(_component_ListHead, {
    leftTitle: _ctx.leftTitle,
    rightTitle: _ctx.rightTitle,
    onTagClick: _ctx.tagClick
  }, null, 8
  /* PROPS */
  , ["leftTitle", "rightTitle", "onTagClick"]), _createCommentVNode(" 歌手列表区域 "), _createVNode(_component_SongerList, {
    class: "scroll",
    songerList: _ctx.songerList
  }, null, 8
  /* PROPS */
  , ["songerList"]), _createCommentVNode(" 数字输入框替代分页器，因为接口没有total，不知道总数据有多少 "), _ctx.songerList.length ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_input_number, {
    modelValue: _ctx.page,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return _ctx.page = $event;
    }),
    min: 1,
    max: 23,
    onChange: _ctx.pageChange
  }, null, 8
  /* PROPS */
  , ["modelValue", "onChange"])])) : _createCommentVNode("v-if", true)])) : _createCommentVNode("v-if", true);
}